<template>
  <div
    class="yhc-ef-kazai-detail-input--notice-by-kazai-type"
    v-if="kazaiType.notice_text"
    :key="`kazaiTypeId-${kazaiType.id}`"
  >
    <div class="yhc-ef-kazai-detail-input--notice-by-kazai-type--title">
      <div class="yhc-ef-kazai-detail-input--notice-by-kazai-type--title--inner">
        <ficon
          type="exclamation-triangle"
          style="font-size: 1.2em"
        />
        {{ kazaiType.notice_title || `${kazaiType.name} をご依頼する場合のご注意事項` }}
      </div>
    </div>
    <YhcPublicWebHtmlContentDisplay
      class="yhc-ef-kazai-detail-input--notice-by-kazai-type--body yhc-richtext-content"
      :html-content="kazaiType.notice_text"
    />
  </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import { ModelYhcKazaiTypesFullRelation } from '../../../../fireModels/yhcDataTypes'

export default {
  name: 'YhcEFKazaiDetailInputNoticeByKazaiType',
  props: {
    kazaiType: {
      type: Object as PropType<ModelYhcKazaiTypesFullRelation>,
      required: true,
    },
  },
}
</script>
<style lang="scss">
.yhc-ef-kazai-detail-input--notice-by-kazai-type {
  background-color: white;
  margin-top: 1.5em;
  overflow: hidden;
  border-radius: var(--yhc-border-radius);
  .yhc-ef-kazai-detail-input--notice-by-kazai-type--title {
    font-size: 0.9em;
    .yhc-ef-kazai-detail-input--notice-by-kazai-type--title--inner {
      padding: 0.3em 0.7em;
      font-weight: bold;
      //margin-top: -4px;
      //margin-left: -4px;
      background-color: var(--yhc-color-warn-red);
      color: white;
      display: inline-block;
    }
  }
  .yhc-ef-kazai-detail-input--notice-by-kazai-type--body {
    font-weight: bold;
    padding: 0.7em 1em 0.1em;
  }
}
</style>
